<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep1ogauc.vue
*@ 컴포넌트설명 :[오클랜드] 예금 상품 > 금리 안내(당좌예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6>NZD ({{ /*개인 고객*/ $t("MDEP-01-02-01-06") }})</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">
            $10,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $20,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $250,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $1,000,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
        </tr>
      </thead>
      <tbody v-if="chequeAccountList1.length > 0">
        <tr v-for="(ca1, i) in chequeAccountList1" :key="i">
          <td>{{ ca1.mtS10000Rate }}</td>
          <td>{{ ca1.mtS20000Rate }}</td>
          <td>{{ ca1.mtS100000Rate }}</td>
          <td>{{ ca1.mtS250000Rate }}</td>
          <td>{{ ca1.mtS1000000Rate }}</td>
        </tr>
      </tbody>
    </table>

    <div class="cont-tit">
      <h6>NZD ({{ /*기업고객*/ $t("MDEP-01-02-01-07") }})</h6>
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>
    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">
            $10,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $20,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $250,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
          <th scope="col">
            $1,000,000
            <em>{{ /*이상*/ $t("MDEP-01-02-01-10") }}</em>
          </th>
        </tr>
      </thead>
      <tbody v-if="chequeAccountList2.length > 0">
        <tr v-for="(ca2, j) in chequeAccountList2" :key="j">
          <td>{{ ca2.mtS10000Rate }}</td>
          <td>{{ ca2.mtS20000Rate }}</td>
          <td>{{ ca2.mtS100000Rate }}</td>
          <td>{{ ca2.mtS250000Rate }}</td>
          <td>{{ ca2.mtS1000000Rate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      currentTab: 0,

      chequeAccountList1: [],
      chequeAccountList2: [],
    };
  },

  created() {
    this.go();
  },

  methods: {
    go() {
      const path = "/deposit/interest/intRateNz1List";

      let params1 = {
        interestInqInItemDTO: {
          dpostLnDstcd: "D",
          operGroupCd: "NZ1",
          ppsnCorpCtnt: "NZ1PS",
          prdctKndCtnt: "NZ101",
        },
      };

      let params2 = {
        interestInqInItemDTO: {
          dpostLnDstcd: "D",
          operGroupCd: "NZ1",
          ppsnCorpCtnt: "NZ1CO",
          prdctKndCtnt: "NZ101",
        },
      };

      // 당좌예금 - 개인
      this.$post(
        path,
        params1,
        this.selectSucc1
      );

      // 당좌예금 - 기업
      this.$post(
        path,
        params2,
        this.selectSucc2
      );
    },

    selectSucc1(res) {
      this.chequeAccountList1 = res.interstList;
    },
    selectSucc2(res) {
      this.chequeAccountList2 = res.interstList;
    },
  },
};
</script>
